import { makeScrollBar } from './functionHelpers';

export const REQUIRED_FIELD = 'Required field';

export const scrollBarMD = makeScrollBar(9);
export const scrollBarSM = makeScrollBar(6);

export const border = `1px solid #DFF2F5`;

export const boxShadow = '0px 4px 8px 0px rgba(0, 0, 0, 0.10)';

export const DATA_TEST_ID_SELECTION = 'selection';
export const DATA_TEST_ID_ATTRIBUTE_NAME = 'data-testid';

export const GUID_EMTY = '00000000-0000-0000-0000-000000000000';
